import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { CircularProgress, Typography, TextField, Box, Card, CardContent } from '@mui/material';
import WebSabitler from '../../../apis/WebSabitler';

const validationSchema = Yup.object({
});

const GuvenlikMetni: React.FC = () => {
    const [isLoad, setIsLoad] = useState(true);
    const [message, setMessage] = useState<string>('');
    const [guvenlikMetni, setGuvenlikMetni] = useState<string>('');

    useEffect(() => {
        const fetchData = async () => {
            setIsLoad(true);
            try {
                const response = await WebSabitler.getWebSabitler();
                if (response) {
                    setGuvenlikMetni(response.data.guvenlikMetni || '');
                } else {
                    setMessage('Beklenen formatta veri gelmedi.');
                }
            } catch (err) {
                console.error(err);
                setMessage('sabitler alınırken hata oluştu.');
            } finally {
                setIsLoad(false);
            }
        };

        fetchData();
    }, []);

    if (isLoad) {
        return (
            <Box
                className="d-flex justify-content-center align-items-center"
                sx={{ height: '100%' }}
            >
                <CircularProgress />
            </Box>
        );
    }


    return (
        <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
                Güvenlik Politikası
            </Typography>

            <Card sx={{ backgroundColor: '#fff', borderRadius: 2, p: 2, boxShadow: 4 }}>
                <CardContent>
                    {message ? (
                        // Eğer hata ya da bilgi mesajı varsa ekranda göster
                        <Typography color="error" align="center">
                            {message}
                        </Typography>
                    ) : (
                        // Aksi takdirde metni salt‐okunur bir TextField içinde göster
                        <Box
                            sx={{
                                border: 1,
                                borderColor: 'divider',
                                borderRadius: 1,
                                p: 2,
                                minHeight: 400,
                                overflowY: 'auto',
                                backgroundColor: 'background.paper',
                                width: '100%',            // Tam genişlik
                                whiteSpace: 'pre-wrap',   // Satır sonlarını ve boşlukları koru
                                fontFamily: 'Roboto, sans-serif', // Typography’ın font’una yakın
                                fontSize: '1rem',         // normal metin boyutu
                                lineHeight: 1.5,
                            }}
                        >
                            {guvenlikMetni}
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default GuvenlikMetni;